module.exports = ".signature_select .ngx-dropdown-button {\n    min-height: 44px !important;\n    margin-top: 5px !important;\n}"